let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lyJwO")).then(() => parcelRequire('8R8tY'));